import React, { useEffect, useState } from 'react';

const TechServicesOverlapped = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [windowWidth, setWindowWidth] = useState(typeof window !== 'undefined' ? window.innerWidth : 1200);

  useEffect(() => {
    const handleScroll = () => {
      const element = document.getElementById('tech-services-overlapped');
      if (element) {
        const position = element.getBoundingClientRect();
        if (position.top < window.innerHeight * 0.75) {
          setIsVisible(true);
        }
      }
    };

    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener('scroll', handleScroll);
    window.addEventListener('resize', handleResize);
    handleScroll();
    
    return () => {
      window.removeEventListener('scroll', handleScroll);
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const isMobile = windowWidth <= 768;
  const isTablet = windowWidth <= 1024;

  const containerStyle = {
    position: 'relative',
    width: '100%',
    maxWidth: '1400px',
    margin: '0 auto',
    height: isMobile ? '700px' : isTablet ? '600px' : '500px',
    padding: isMobile ? '10px' : '20px',
    boxSizing: 'border-box',
  };

  const mainImageContainerStyle = {
    position: 'relative',
    width: isMobile ? '100%' : isTablet ? '85%' : '75%',
    height: isMobile ? '60%' : '100%',
    backgroundColor: '#2a0044',
    borderRadius: '15px',
    overflow: 'hidden',
    opacity: isVisible ? '1' : '0',
    transform: isVisible ? 'translateY(0)' : 'translateY(30px)',
    transition: 'all 0.6s ease-out',
  };

  const mainImageStyle = {
    width: '100%',
    height: '100%',
    objectFit: 'cover',
  };

  const patternOverlayStyle = {
    position: 'absolute',
    top: isMobile ? 0 : 10,
    right: isMobile ? 0 : -10,
    width: isMobile ? '100%' : '40%',
    height: '100%',
    background: 'repeating-linear-gradient(45deg, rgba(73, 0, 130, 0.5) 0px, rgba(73, 0, 130, 0.5) 10px, transparent 10px, transparent 20px)',
    zIndex: 1,
  };

  const techOverlayStyle = {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    zIndex: 2,
  };

  const cardsContainerStyle = {
    position: isMobile ? 'relative' : 'absolute',
    right: isMobile ? 'auto' : '0',
    bottom: isMobile ? '0' : '40px',
    display: 'grid',
    gridTemplateColumns: isMobile ? 'repeat(2, 1fr)' : isTablet ? 'repeat(2, 160px)' : 'repeat(2, 180px)',
    gap: isMobile ? '10px' : '15px',
    zIndex: 3,
    marginTop: isMobile ? '20px' : '0',
    width: isMobile ? '100%' : 'auto',
  };

  const cardStyle = (index) => ({
    background: 'white',
    padding: isMobile ? '15px' : '20px',
    borderRadius: '8px',
    textAlign: 'center',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    opacity: isVisible ? '1' : '0',
    transform: isVisible ? 'translateY(0)' : 'translateY(30px)',
    transition: 'all 0.6s ease-out',
    transitionDelay: `${0.2 + index * 0.1}s`,
    boxShadow: '0 4px 15px rgba(0, 0, 0, 0.2)',
  });

  const iconStyle = {
    width: isMobile ? '35px' : '45px',
    height: isMobile ? '35px' : '45px',
    background: '#400684',
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginBottom: '10px',
  };

  const titleStyle = {
    margin: 0,
    fontSize: isMobile ? '11px' : '13px',
    fontWeight: '600',
    color: '#333',
  };

  // Tech UI Elements Component with responsive positioning
  const TechElement = ({ style }) => (
    <div style={{
      position: 'absolute',
      borderColor: '#00B4D8',
      borderStyle: 'solid',
      display: isMobile ? 'none' : 'block',
      ...style,
    }} />
  );

  const services = [
    { title: 'DEVELOPMENT', icon: '🔧' },
    { title: '5G NETWORK', icon: '📡' },
    { title: 'AI PRODUCTS', icon: '🤖' },
    { title: 'AUTOMATION', icon: '⚙️' },
  ];

  return (
    <div id="tech-services-overlapped" style={containerStyle}>
      <div style={mainImageContainerStyle}>
        <img 
          src="/finger.jpg" 
          alt="Technology Interface" 
          style={mainImageStyle}
        />
        {/* <div style={patternOverlayStyle} /> */}
        <div style={techOverlayStyle}>
          <TechElement style={{
            width: isTablet ? '20px' : '30px',
            height: isTablet ? '20px' : '30px',
            top: '20px',
            left: '20px',
            borderWidth: '2px 0 0 2px',
          }} />
          <TechElement style={{
            width: isTablet ? '60px' : '80px',
            height: '2px',
            top: '50%',
            right: '40px',
            background: '#00B4D8',
          }} />
          <TechElement style={{
            width: isTablet ? '100px' : '120px',
            height: isTablet ? '100px' : '120px',
            top: '40%',
            left: '60%',
            transform: 'translate(-50%, -50%)',
            borderRadius: '50%',
            borderWidth: '2px',
            borderColor: '#00B4D8',
          }} />
          <div style={{
            position: 'absolute',
            top: '40%',
            left: '60%',
            transform: 'translate(-50%, -50%)',
            width: isTablet ? '60px' : '80px',
            height: isTablet ? '60px' : '80px',
            border: '2px solid #00B4D8',
            borderRadius: '50%',
            animation: 'pulse 2s infinite',
            display: isMobile ? 'none' : 'block',
          }} />
        </div>
      </div>
      
      <div style={cardsContainerStyle}>
        {services.map((service, index) => (
          <div key={service.title} style={cardStyle(index)}>
            <div style={iconStyle}>
              <span role="img" aria-label={service.title} style={{fontSize: isMobile ? '16px' : '20px'}}>
                {service.icon}
              </span>
            </div>
            <h3 style={titleStyle}>{service.title}</h3>
          </div>
        ))}
      </div>

      <style>
        {`
          @keyframes pulse {
            0% { transform: translate(-50%, -50%) scale(1); opacity: 0.8; }
            50% { transform: translate(-50%, -50%) scale(1.2); opacity: 0.4; }
            100% { transform: translate(-50%, -50%) scale(1); opacity: 0.8; }
          }
        `}
      </style>
    </div>
  );
};

export default TechServicesOverlapped;